
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { batchAddDiyEvaluate, getTaskDiyEvaluateList } from "@/api/orderTask";
import { float } from "html2canvas/dist/types/css/property-descriptors/float";

@Component({
  name: "OrderServicerEvaluateNew",
  components: {},
})
export default class extends Vue {
  private evaluateDataList: any = {};
  private textarea = "";

  private tableDataList: any = {};

  private isPl = false;

  created() {
    this.evaluateDataList = JSON.parse(this.$route.query.orderList as string);
    this.isPl = parseInt(this.$route.query.isPL as string) === 1;
    console.log(this.evaluateDataList)
    this.getTaskDiyEvaluateList();
  }
  private getTaskDiyEvaluateList() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
    };
    let arr: any = [];
    this.evaluateDataList.map((evaluateData: any) => {
      console.log(11111)
      arr.push({
        order_id: evaluateData.order.id,
        order_service_id: evaluateData.order_service.id,
        service_company_id: evaluateData.order_service.servicer_company_id,
      });
    });
    params.search_json = JSON.stringify(arr);
    getTaskDiyEvaluateList(params).then((res: any) => {
      if (res.data) {
        this.tableDataList = res.data.list;
      }
    });
  }

  private numberHandle(d: any, val: any, order: any) {
    // if (d.score_num === val) {
    //   d.score_num = "";
    //   return;
    // } else {
    d.score_num = val;
    // }
    this.tableDataList.map((tab: any) => {
      if (tab.order.id === order.order_id) {
        tab.service_diy_evaluate_list.map((ss: any) => {
          if (ss.id === order.id) {
            ss.diy_evaluate_score_num = 0;
            ss.evaluate_dimension.map((dd: any) => {
              if (dd.score_num) {
                ss.diy_evaluate_score_num += (dd.score_num * dd.weight) / 10;
              }
            });
            ss.diy_evaluate_score_num = parseFloat(
              ss.diy_evaluate_score_num
            ).toFixed(1);
            ss.service_diy_evaluate_score_num = ss.diy_evaluate_score_num;
          }
        });
      }
    });
    this.$forceUpdate();
  }
  private submitAllCus() {
    this.tableDataList.map((val: any) => {
      val.repair_diy_evaluate_list.map((o: any) => {
        val.service_diy_evaluate_list.map((s: any) => {
          if (o.id === s.id) {
            s.service_diy_evaluate_remark = o.repair_diy_evaluate_remark;
            o.evaluate_dimension.map((oDimension: any) => {
              s.evaluate_dimension.map((sDimension: any) => {
                if (oDimension.dimension_id === sDimension.dimension_id) {
                  sDimension.score_num = oDimension.score_num;
                }
              });
            });
          }
        });
      });
      val.service_diy_evaluate_list.map(async(s: any) => {
        s.diy_evaluate_score_num = 0;
        await s.evaluate_dimension.map((evaluateDimension: any) => {
          if (evaluateDimension.score_num) {
            s.diy_evaluate_score_num +=
              (evaluateDimension.score_num * evaluateDimension.weight) / 10;
          }
        });
        s.diy_evaluate_score_num = parseFloat(s.diy_evaluate_score_num).toFixed(
          1
        );
        s.service_diy_evaluate_score_num = s.diy_evaluate_score_num;
      });
    });
  }
  private submitCus(val: any) {
    val.repair_diy_evaluate_list.map((o: any) => {
      val.service_diy_evaluate_list.map((s: any) => {
        if (o.id === s.id) {
          s.service_diy_evaluate_remark = o.repair_diy_evaluate_remark;
          o.evaluate_dimension.map((oDimension: any) => {
            s.evaluate_dimension.map((sDimension: any) => {
              if (oDimension.dimension_id === sDimension.dimension_id) {
                sDimension.score_num = oDimension.score_num;
              }
            });
          });
        }
      });
    });
    val.service_diy_evaluate_list.map(async(s: any) => {
      s.diy_evaluate_score_num = 0;
      await s.evaluate_dimension.map((evaluateDimension: any) => {
        if (evaluateDimension.score_num) {
          s.diy_evaluate_score_num +=
            (evaluateDimension.score_num * evaluateDimension.weight) / 10;
        }
      });
      s.diy_evaluate_score_num = parseFloat(s.diy_evaluate_score_num).toFixed(
        1
      );
      s.service_diy_evaluate_score_num = s.diy_evaluate_score_num;
    });
  }

  private resetCus(val: any) {
    this.getTaskDiyEvaluateList();
  }

  private async submitEvaluate() {
    let err: any = [];
    let arr: any = [];
    await this.tableDataList.map(async(tab: any) => {
      let o: any = {
        order_id: tab.order.id,
        order_service_id: tab.order_service.id,
        service_company_id: tab.order_service.servicer_company_id,
        evaluate_json: [],
      };
      let evaList: any = [];
      await tab.service_diy_evaluate_list.map(async(ss: any) => {
        let eva: any = {
          order_task_id: ss.id,
          diy_evaluate_score_num: ss.service_diy_evaluate_score_num,
          diy_evaluate_remark:ss.service_diy_evaluate_remark,
          evaluate_dimension: ss.evaluate_dimension,
        };
        await ss.evaluate_dimension.map((dd: any) => {
          if (!(dd.score_num || parseInt(dd.score_num) === 0)) {
            err.push({
              order: tab,
              task: ss,
              dimension: dd,
            });
          }
        });
        evaList.push(eva);
      });
      o.evaluate_json = evaList;
      arr.push(o);
    });
    if (err && err.length > 0) {
      this.showErrorMsg(
        "请选择订单号为" +
          err[0].order.order.order_num +
          ",任务编号为" +
          err[0].order.order.order_num +
          "-" +
          err[0].task.id +
          "的" +
          err[0].dimension.dimension_name +
          '"的评分"'
      );
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      source_type: 2,
      batch_evaluate_json: JSON.stringify(arr),
    };
    batchAddDiyEvaluate(params)
      .then((res: any) => {
        this.showSucessMsg(res.msg);
        this.$router.go(-1);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  private detailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: "/OrderServicer/todetail",
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
        viewType: "2",
      },
    });
    window.open(routeData.href);

    // this.showDrawerDetails = true;
    // this.DetailsDataQuery = {
    //   order_service_id: val.order_service.id,
    //   company_id: val.order_service.servicer_company_id,
    //   viewType: this.viewType + ''
    // };
  }
  private getTagsHtml(r: any) {
    let kind = "";
    let kindType = "";
    let abnormal = "";
    let plain = "plain";
    if (parseInt(r.order.order_type) === 1) {
      kind = "其他";
      kindType = "warning";
    } else if (parseInt(r.order.order_type) === 2) {
      kind = "维保";
      kindType = "success";
    } else if (parseInt(r.order.order_type) === 3) {
      kind = "安装";
      kindType = "danger";
    } else if (parseInt(r.order.order_type) === 4) {
      kind = "巡检";
      kindType = "";
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = "维保";
      kindType = "success";
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部";
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = "";
    let darkplain = "dark";
    if (parseInt(r.order_service.charge) === 1) {
      charge = "收费";
    }

    let expedited = "";
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = "加急";
    }

    // 2019-05-23 迭代 订单排位
    let ranking = "";
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + "号";
      }
    }

    // 审核标识
    let check = "";
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = "审核";
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    let urgent = "";
    if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
      urgent = "已催单" + r.order.reminder.count + "次";
    }

    return [
      {
        type: "",
        label: source,
        plain: darkplain,
      },
      {
        type: kindType,
        label: kind,
        plain: plain,
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: "danger",
        label: charge,
        plain: darkplain,
      },
      {
        type: "danger",
        label: expedited,
        plain: darkplain,
      },
      {
        type: "danger",
        label: ranking,
        plain: darkplain,
      },
      {
        type: "warning",
        label: check,
        plain: darkplain,
      },
      {
        type: "warning",
        label: urgent,
        plain: plain,
      },
    ];
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSucessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
